import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import type { Mutation, MutationAcceptPrivacyPolicyArgs } from 'graphql-models';
import acceptPrivacyPolicyMutation from 'walden-trace-app/graphql/user/accept-privacy-policy.graphql';
import type { PrivacyPolicyModel } from 'walden-trace-app/routes/privacy-policy';
import type ApiService from 'walden-trace-app/services/api';

export default class PrivacyPolicyController extends Controller {
  declare model: PrivacyPolicyModel;

  queryParams = ['redirectURL'];

  @service('api') declare apiService: ApiService;
  @service('router') declare routerService: RouterService;

  @tracked redirectURL = '';

  get user() {
    return this.model.user;
  }

  @action
  goToRedirectRoute() {
    const requestedRouteName = this.redirectURL;
    const routeInfo = this.routerService.recognize(requestedRouteName);

    const redirectRoute = routeInfo?.name.startsWith('app.') ? requestedRouteName : 'app';
    this.routerService.replaceWith(redirectRoute);
  }

  acceptPrivacyPolicy = task(async () => {
    try {
      if (!this.user) {
        throw new Error('No user found to accept privacy policy for');
      }

      await this.apiService.mutate<
        {
          acceptPrivacyPolicy: Mutation['acceptPrivacyPolicy'];
        },
        MutationAcceptPrivacyPolicyArgs
      >({
        mutation: acceptPrivacyPolicyMutation,
        variables: {
          id: this.user.id,
        },
      });

      this.routerService.refresh();

      this.goToRedirectRoute();
    } catch (e) {
      console.error('Failed to accept privacy policy', e, typeof e);
    }
  });
}
